import {
  integer,
  real,
  sqliteTable,
  text,
  uniqueIndex,
} from "drizzle-orm/sqlite-core";

export const playEvents = sqliteTable(
  "play_events",
  {
    id: text().primaryKey(),
    play_id: text().notNull(),
    seq: integer().notNull(),
    kind: text({ enum: ["start", "heartbeat", "stop"] }).notNull(),
    client_ts: text().notNull(),
    position: real().notNull(),
    song_id: text(),
    collection: text(),
    country_code: text(),
    reason: text({
      enum: ["track_change", "queue_end", "pause", "user", "unload"],
    }),
    seeked: integer({ mode: "boolean" }),
    token: text(),
    created_at: integer().notNull(),
  },
  (table) => [uniqueIndex("play_events_play_seq").on(table.play_id, table.seq)],
);

export const plays = sqliteTable("plays", {
  play_id: text().primaryKey(),
  // The account that started the play; only it may send the play's events.
  // Null for plays started before owners were recorded.
  user_id: text(),
  token: text(),
  last_seq: integer().notNull().default(0),
  interval_seconds: integer().notNull().default(30),
  song_id: text().notNull(),
  started_at: integer().notNull(),
  // Survives acknowledgement/deletion of the last outbox event for pruning.
  last_event_at: integer().notNull(),
});
